import { TermsOfUse } from '../terms-of-use';

import dsTokens from '@frete.com/fuel-foundation/fretebras/theme.json';
import { FuelButton, FuelTypography } from '@frete.com/fuel-react';
import { FuelModal } from '@frete.com/fuel-station-react';
import { FC } from 'react';

import { PORTAL } from '@/constants';

import * as Styled from './styled';
import { TermsModalProps } from './types';

export const TermsModal: FC<TermsModalProps> = ({
  isOpen,
  isChecked,
  isButtonLoading,
  onClose,
  onClickCheck,
  onClickReleaseAccess,
}) => (
  <FuelModal
    isOpen={isOpen}
    onClose={onClose}
    width="lg"
    removePortalOnDestroy={false}
    portalName={`.${PORTAL}`}
    data-testid="terms-modal"
  >
    <FuelTypography
      weight="bold"
      color="neutral-strong"
      size="heading-sm"
      spacingBottom={parseFloat(dsTokens.spacing.km4)}
    >
      Termos e condições
    </FuelTypography>
    <TermsOfUse />
    <Styled.Checkbox
      checked={isChecked}
      onFuel-change={onClickCheck}
      label="Li e estou de acordo com os termos de utilização da GR Fretebras"
    />
    <FuelTypography size="caption" color="neutral-default">
      Ao Liberar acesso, você atesta que sua apólice de seguros contempla a Skymark como gerenciadora de risco e não
      possui nenhuma restrição a essa GR.
    </FuelTypography>
    <Styled.Footer>
      <FuelButton size="large" variant="tertiary" onClick={onClose}>
        Cancelar
      </FuelButton>
      <FuelButton size="large" onClick={onClickReleaseAccess} disabled={!isChecked} isLoading={isButtonLoading}>
        Liberar acesso
      </FuelButton>
    </Styled.Footer>
  </FuelModal>
);
